/**
 * @typedef {Object} OutputField
 * @property {string} name - Field identifier
 * @property {string|function} label - Display label or function returning label
 * @property {function} [checked] - Function determining if field is selected by default
 * @property {function} [visible] - Function determining if field should be shown
 * @property {boolean} [forceChecked] - If true, field is always selected and cannot be unchecked
 * @property {function} [disabled] - Function determining if fields should be disabled
 */

const countyLevelServicesOutputFields = [
  {
    name: "npi",
    label: "Organization NPI",
    checked: ({ common }) => !!common?.outputs?.npi
  },
  {
    name: "name",
    label: "Organization Name",
    checked: ({ common }) => !!common?.outputs?.name
  },
  {
    name: "classification",
    label: "Organization Classification",
    checked: ({ common }) => !!common?.outputs?.classification
  },
  {
    name: "specialization",
    label: "Organization Specialization",
    checked: ({ common }) => !!common?.outputs?.specialization
  },

  {
    name: "city",
    label: "City",
    checked: ({ common }) => !!common?.outputs?.city
  },
  {
    name: "stateName",
    label: "State",
    checked: ({ common }) => !!common?.outputs?.stateName
  },
  {
    name: "zipCode",
    label: "ZIP Code",
    checked: ({ common }) => !!common?.outputs?.zipCode
  },

  {
    name: "fipsCode",
    label: "Patient FIPS County",
    checked: ({ common }) => !!common?.outputs?.fipsCode
  },
  {
    name: "fipsCountyName",
    label: "Patient FIPS County Name",
    checked: ({ common }) => !!common?.outputs?.fipsCountyName
  },
  {
    name: "fipsState",
    label: "Patient FIPS State",
    checked: ({ common }) => !!common?.outputs?.fipsState
  },

  {
    name: "codeServiceLine",
    label: ({ common }) => {
      switch (common?.reportType) {
        case "cpt/hcpcs":
          return "CPT Service Line";
        case "primaryDiagnosis":
          return "ICD-10 Service Line";
        case "msdrg":
          return "MSDRG Service Line";
        default:
          return "Service Line";
      }
    },
    checked: ({ common }) => !!common?.outputs?.codeServiceLine
  },

  {
    name: "source",
    label: "Source",
    checked: ({ common }) => !!common?.outputs?.source
  },

  {
    name: "distinctClaimsCount",
    label: "Count of Distinct Claims",
    checked: ({ common }) => !!common?.outputs?.distinctClaimsCount
  },
  {
    name: "distinctPatientsCount",
    label: "Count of Distinct Patients",
    checked: ({ common }) => !!common?.outputs?.distinctPatientsCount
  },
  {
    name: "proceduresCount",
    label: "Count of Procedures",
    checked: ({ common }) => !!common?.outputs?.proceduresCount
  },
  {
    name: "sumCharges",
    label: "Sum of Charges",
    checked: ({ common }) => !!common?.outputs?.sumCharges
  }
];

export default countyLevelServicesOutputFields;
